var map = {
	"./academy.jpg": 1307,
	"./ace-hardware.jpg": 1308,
	"./acklands-grainger.jpg": 1309,
	"./amazon-uk.png": 1310,
	"./amazon.jpg": 1311,
	"./amazonCA.jpg": 1312,
	"./basics.jpg": 1313,
	"./bjs.jpg": 1314,
	"./cabelas.jpg": 1315,
	"./costco-uk.png": 1316,
	"./costco.jpg": 1317,
	"./de-raat.jpg": 1318,
	"./ferrimax.png": 1319,
	"./home-depot.jpg": 1320,
	"./home-hardware.jpg": 1321,
	"./lowes.jpg": 1322,
	"./ncr-angola.jpg": 1323,
	"./officedepot-officemax.jpg": 1324,
	"./officemax-grand-and-toy.jpg": 1325,
	"./powered-by-hatch.svg": 336,
	"./sams-club.jpg": 1326,
	"./staples.jpg": 1327,
	"./tmall.jpg": 1328,
	"./walmart.jpg": 1329
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;



//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy ^\.\/.*$
// module id = 1340
// module chunks = 0